/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface CustomersService {
  /** @summary Search Customers */
  searchCustomers: {
    /** @summary Search Customers */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<SearchCustomersSchema, SearchCustomersParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<SearchCustomersParameters, TMeta, TSignal>,
      client?: (
        schema: SearchCustomersSchema,
        options: {
          parameters: SearchCustomersParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<SearchCustomersData, SearchCustomersError>>
    ): Promise<RequestFnResponse<SearchCustomersData, SearchCustomersError>>;
    /** @summary Search Customers */
    getQueryKey(
      parameters: DeepReadonly<SearchCustomersParameters>
    ): ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.customersService.searchCustomers.useQuery({
     *     query: {
     *         page: page,
     *         limit: limit
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchCustomersData>(
      parameters:
        | ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          SearchCustomersData,
          SearchCustomersError,
          TData,
          ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<SearchCustomersError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.customersService.searchCustomers.useQuery({
     *     query: {
     *         page: page,
     *         limit: limit
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchCustomersData>(
      parameters:
        | ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          SearchCustomersData,
          SearchCustomersError,
          TData,
          ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<SearchCustomersError>>;
    /** @summary Search Customers */
    getInfiniteQueryKey(
      parameters: DeepReadonly<SearchCustomersParameters>
    ): ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customersService.searchCustomers.useInfiniteQuery({
     *     query: {
     *         page: page,
     *         limit: limit
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage,
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchCustomersParameters,
      TQueryFnData = SearchCustomersData,
      TData = OperationInfiniteData<TQueryFnData, SearchCustomersParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchCustomersError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<SearchCustomersError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customersService.searchCustomers.useInfiniteQuery({
     *     query: {
     *         page: page,
     *         limit: limit
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage,
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchCustomersParameters,
      TQueryFnData = SearchCustomersData,
      TData = OperationInfiniteData<TQueryFnData, SearchCustomersParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchCustomersError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchCustomersData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<SearchCustomersError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const searchCustomersTotal = qraft.customersService.searchCustomers.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const searchCustomersByParametersTotal = qraft.customersService.searchCustomers.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             page: page,
     *             limit: limit
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const searchCustomersResults = qraft.customersService.searchCustomers.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1,
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2,
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * searchCustomersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const searchCustomersCombinedResults = qraft.customersService.searchCustomers.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1,
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2,
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * searchCustomersCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          SearchCustomersSchema,
          SearchCustomersParameters,
          SearchCustomersData,
          SearchCustomersError
        >
      >,
      TCombinedResult = Array<UseQueryResult<SearchCustomersData, SearchCustomersError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<SearchCustomersData, SearchCustomersError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.customersService.searchCustomers.useSuspenseQuery({
     *     query: {
     *         page: page,
     *         limit: limit
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = SearchCustomersData>(
      parameters:
        | ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          SearchCustomersData,
          SearchCustomersError,
          TData,
          ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<SearchCustomersError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customersService.searchCustomers.useSuspenseInfiniteQuery({
     *     query: {
     *         page: page,
     *         limit: limit
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage,
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends SearchCustomersParameters, TData = SearchCustomersData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          SearchCustomersData,
          SearchCustomersError,
          OperationInfiniteData<TData, SearchCustomersParameters>,
          ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchCustomersData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, SearchCustomersParameters>,
      OperationError<SearchCustomersError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search Customers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const searchCustomersData = qraft.customersService.searchCustomers.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1,
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2,
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * searchCustomersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const searchCustomersCombinedData = qraft.customersService.searchCustomers.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1,
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2,
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * searchCustomersCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          SearchCustomersSchema,
          SearchCustomersParameters,
          SearchCustomersData,
          SearchCustomersError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<SearchCustomersData, SearchCustomersError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<SearchCustomersData, SearchCustomersError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Search Customers */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchCustomersSchema,
        SearchCustomersData,
        SearchCustomersParameters,
        SearchCustomersError
      >
    ): Promise<SearchCustomersData>;
    /** @summary Search Customers */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchCustomersSchema,
        SearchCustomersData,
        SearchCustomersParameters,
        SearchCustomersError
      >
    ): Promise<void>;
    /** @summary Search Customers */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        SearchCustomersSchema,
        SearchCustomersData,
        SearchCustomersParameters,
        SearchCustomersError
      >
    ): Promise<SearchCustomersData>;
    /** @summary Search Customers */
    fetchInfiniteQuery<TPageParam extends SearchCustomersParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchCustomersSchema,
        SearchCustomersData,
        SearchCustomersParameters,
        DeepReadonly<TPageParam>,
        SearchCustomersError
      >
    ): Promise<OperationInfiniteData<SearchCustomersData, SearchCustomersParameters>>;
    /** @summary Search Customers */
    prefetchInfiniteQuery<TPageParam extends SearchCustomersParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchCustomersSchema,
        SearchCustomersData,
        SearchCustomersParameters,
        DeepReadonly<TPageParam>,
        SearchCustomersError
      >
    ): Promise<void>;
    /** @summary Search Customers */
    ensureInfiniteQueryData<TPageParam extends SearchCustomersParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        SearchCustomersSchema,
        SearchCustomersData,
        SearchCustomersParameters,
        DeepReadonly<TPageParam>,
        SearchCustomersError
      >
    ): Promise<OperationInfiniteData<SearchCustomersData, SearchCustomersParameters>>;
    /** @summary Search Customers */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>
    ): SearchCustomersData | undefined;
    /** @summary Search Customers */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>
    ): OperationInfiniteData<SearchCustomersData, SearchCustomersParameters> | undefined;
    /** @summary Search Customers */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>,
            data: NoInfer<OperationInfiniteData<SearchCustomersData, SearchCustomersParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>,
            data: SearchCustomersData | undefined,
          ]
        >;
    /** @summary Search Customers */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>
        | DeepReadonly<SearchCustomersParameters>
    ): QueryState<SearchCustomersData, SearchCustomersError> | undefined;
    /** @summary Search Customers */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<SearchCustomersParameters>
        | ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>
    ):
      | QueryState<OperationInfiniteData<SearchCustomersData, SearchCustomersParameters>, SearchCustomersError>
      | undefined;
    /** @summary Search Customers */
    setQueryData(
      parameters:
        | DeepReadonly<SearchCustomersParameters>
        | ServiceOperationQueryKey<SearchCustomersSchema, SearchCustomersParameters>,
      updater: Updater<
        NoInfer<SearchCustomersData> | undefined,
        NoInfer<DeepReadonly<SearchCustomersData>> | undefined
      >,
      options?: SetDataOptions
    ): SearchCustomersData | undefined;
    /** @summary Search Customers */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<SearchCustomersParameters>
        | ServiceOperationInfiniteQueryKey<SearchCustomersSchema, SearchCustomersParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<SearchCustomersData, SearchCustomersParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<SearchCustomersData, SearchCustomersParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<SearchCustomersData, SearchCustomersParameters> | undefined;
    /** @summary Search Customers */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >,
      updater: Updater<NoInfer<SearchCustomersData> | undefined, NoInfer<SearchCustomersData> | undefined>,
      options?: SetDataOptions
    ): Array<SearchCustomersData | undefined>;
    /** @summary Search Customers */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        SearchCustomersSchema,
        SearchCustomersData,
        TInfinite,
        SearchCustomersParameters,
        SearchCustomersError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Search Customers */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Search Customers */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Search Customers */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
    ): void;
    /** @summary Search Customers */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Search Customers */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
        | QueryFiltersByQueryKey<
            SearchCustomersSchema,
            SearchCustomersData,
            TInfinite,
            SearchCustomersParameters,
            SearchCustomersError
          >
    ): number;
    schema: SearchCustomersSchema;
    types: {
      parameters: SearchCustomersParameters;
      data: SearchCustomersData;
      error: SearchCustomersError;
    };
  };
  /** @summary Create Customer */
  createCustomer: {
    /** @summary Create Customer */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateCustomerBody, CreateCustomerParameters, TMeta, TSignal>,
      client?: (
        schema: CreateCustomerSchema,
        options: ServiceOperationMutationFnOptions<CreateCustomerBody, CreateCustomerParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateCustomerData, CreateCustomerError>>
    ): Promise<RequestFnResponse<CreateCustomerData, CreateCustomerError>>;
    /** @summary Create Customer */
    getMutationKey(
      parameters: DeepReadonly<CreateCustomerParameters> | void
    ): ServiceOperationMutationKey<CreateCustomerSchema, CreateCustomerParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Customer
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.createCustomer.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.createCustomer.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateCustomerBody, TContext = unknown>(
      parameters: DeepReadonly<CreateCustomerParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateCustomerSchema,
        CreateCustomerData,
        CreateCustomerParameters,
        TVariables,
        OperationError<CreateCustomerError>,
        TContext
      >
    ): UseMutationResult<CreateCustomerData, OperationError<CreateCustomerError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Customer
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.createCustomer.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.createCustomer.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<CreateCustomerBody, CreateCustomerParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateCustomerSchema,
        CreateCustomerData,
        CreateCustomerParameters,
        TVariables,
        OperationError<CreateCustomerError>,
        TContext
      >
    ): UseMutationResult<CreateCustomerData, OperationError<CreateCustomerError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Customer
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createCustomerTotal = qraft.customersService.createCustomer.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createCustomerTotal = qraft.customersService.createCustomer.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerBody,
            CreateCustomerData,
            CreateCustomerParameters,
            OperationError<CreateCustomerError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerSchema,
            CreateCustomerBody,
            CreateCustomerData,
            CreateCustomerParameters,
            OperationError<CreateCustomerError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Customer
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createCustomerPendingMutationVariables = qraft.customersService.createCustomer.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createCustomerMutationData = qraft.customersService.createCustomer.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateCustomerData,
        OperationError<CreateCustomerError>,
        MutationVariables<CreateCustomerBody, CreateCustomerParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerBody,
            CreateCustomerData,
            CreateCustomerParameters,
            OperationError<CreateCustomerError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerSchema,
            CreateCustomerBody,
            CreateCustomerData,
            CreateCustomerParameters,
            OperationError<CreateCustomerError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateCustomerData,
          OperationError<CreateCustomerError>,
          MutationVariables<CreateCustomerBody, CreateCustomerParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create Customer */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerBody,
            CreateCustomerData,
            CreateCustomerParameters,
            OperationError<CreateCustomerError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerSchema,
            CreateCustomerBody,
            CreateCustomerData,
            CreateCustomerParameters,
            OperationError<CreateCustomerError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Customer
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.customersService.createCustomer.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.customersService.createCustomer.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateCustomerBody,
              CreateCustomerData,
              CreateCustomerParameters,
              OperationError<CreateCustomerError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCustomerSchema,
              CreateCustomerBody,
              CreateCustomerData,
              CreateCustomerParameters,
              OperationError<CreateCustomerError>,
              TContext
            >
      ):
        | Mutation<
            CreateCustomerData,
            CreateCustomerError,
            MutationVariables<CreateCustomerBody, CreateCustomerParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateCustomerBody,
              CreateCustomerData,
              CreateCustomerParameters,
              OperationError<CreateCustomerError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCustomerSchema,
              CreateCustomerBody,
              CreateCustomerData,
              CreateCustomerParameters,
              OperationError<CreateCustomerError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateCustomerData,
          CreateCustomerError,
          MutationVariables<CreateCustomerBody, CreateCustomerParameters>,
          TContext
        >
      >;
    };
    schema: CreateCustomerSchema;
    types: {
      parameters: CreateCustomerParameters;
      data: CreateCustomerData;
      error: CreateCustomerError;
      body: CreateCustomerBody;
    };
  };
  /**
   * @summary Get Customer
   * @description Gets a customer.
   */
  getCustomer: {
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetCustomerSchema, GetCustomerParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetCustomerParameters, TMeta, TSignal>,
      client?: (
        schema: GetCustomerSchema,
        options: {
          parameters: GetCustomerParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetCustomerData, GetCustomerError>>
    ): Promise<RequestFnResponse<GetCustomerData, GetCustomerError>>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    getQueryKey(
      parameters: DeepReadonly<GetCustomerParameters>
    ): ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.customersService.getCustomer.useQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCustomerData>(
      parameters:
        | ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCustomerData,
          GetCustomerError,
          TData,
          ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCustomerError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.customersService.getCustomer.useQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCustomerData>(
      parameters:
        | ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCustomerData,
          GetCustomerError,
          TData,
          ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCustomerError>>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCustomerParameters>
    ): ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customersService.getCustomer.useInfiniteQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCustomerParameters,
      TQueryFnData = GetCustomerData,
      TData = OperationInfiniteData<TQueryFnData, GetCustomerParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCustomerError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCustomerError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customersService.getCustomer.useInfiniteQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCustomerParameters,
      TQueryFnData = GetCustomerData,
      TData = OperationInfiniteData<TQueryFnData, GetCustomerParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCustomerError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCustomerData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCustomerError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCustomerTotal = qraft.customersService.getCustomer.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCustomerByParametersTotal = qraft.customersService.getCustomer.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<GetCustomerSchema, GetCustomerData, TInfinite, GetCustomerParameters, GetCustomerError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCustomerResults = qraft.customersService.getCustomer.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCustomerCombinedResults = qraft.customersService.getCustomer.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<GetCustomerSchema, GetCustomerParameters, GetCustomerData, GetCustomerError>
      >,
      TCombinedResult = Array<UseQueryResult<GetCustomerData, GetCustomerError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetCustomerData, GetCustomerError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.customersService.getCustomer.useSuspenseQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCustomerData>(
      parameters:
        | ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCustomerData,
          GetCustomerError,
          TData,
          ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCustomerError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customersService.getCustomer.useSuspenseInfiniteQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetCustomerParameters, TData = GetCustomerData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCustomerData,
          GetCustomerError,
          OperationInfiniteData<TData, GetCustomerParameters>,
          ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCustomerData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCustomerParameters>,
      OperationError<GetCustomerError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Customer
     * @description Gets a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCustomerData = qraft.customersService.getCustomer.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCustomerCombinedData = qraft.customersService.getCustomer.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<GetCustomerSchema, GetCustomerParameters, GetCustomerData, GetCustomerError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetCustomerData, GetCustomerError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetCustomerData, GetCustomerError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCustomerSchema,
        GetCustomerData,
        GetCustomerParameters,
        GetCustomerError
      >
    ): Promise<GetCustomerData>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCustomerSchema,
        GetCustomerData,
        GetCustomerParameters,
        GetCustomerError
      >
    ): Promise<void>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCustomerSchema,
        GetCustomerData,
        GetCustomerParameters,
        GetCustomerError
      >
    ): Promise<GetCustomerData>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    fetchInfiniteQuery<TPageParam extends GetCustomerParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCustomerSchema,
        GetCustomerData,
        GetCustomerParameters,
        DeepReadonly<TPageParam>,
        GetCustomerError
      >
    ): Promise<OperationInfiniteData<GetCustomerData, GetCustomerParameters>>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    prefetchInfiniteQuery<TPageParam extends GetCustomerParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCustomerSchema,
        GetCustomerData,
        GetCustomerParameters,
        DeepReadonly<TPageParam>,
        GetCustomerError
      >
    ): Promise<void>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    ensureInfiniteQueryData<TPageParam extends GetCustomerParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCustomerSchema,
        GetCustomerData,
        GetCustomerParameters,
        DeepReadonly<TPageParam>,
        GetCustomerError
      >
    ): Promise<OperationInfiniteData<GetCustomerData, GetCustomerParameters>>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>
    ): GetCustomerData | undefined;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>
    ): OperationInfiniteData<GetCustomerData, GetCustomerParameters> | undefined;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<GetCustomerSchema, GetCustomerData, TInfinite, GetCustomerParameters, GetCustomerError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>,
            data: NoInfer<OperationInfiniteData<GetCustomerData, GetCustomerParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>,
            data: GetCustomerData | undefined,
          ]
        >;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>
        | DeepReadonly<GetCustomerParameters>
    ): QueryState<GetCustomerData, GetCustomerError> | undefined;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCustomerParameters>
        | ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>
    ): QueryState<OperationInfiniteData<GetCustomerData, GetCustomerParameters>, GetCustomerError> | undefined;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetCustomerParameters>
        | ServiceOperationQueryKey<GetCustomerSchema, GetCustomerParameters>,
      updater: Updater<NoInfer<GetCustomerData> | undefined, NoInfer<DeepReadonly<GetCustomerData>> | undefined>,
      options?: SetDataOptions
    ): GetCustomerData | undefined;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCustomerParameters>
        | ServiceOperationInfiniteQueryKey<GetCustomerSchema, GetCustomerParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetCustomerData, GetCustomerParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetCustomerData, GetCustomerParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetCustomerData, GetCustomerParameters> | undefined;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >,
      updater: Updater<NoInfer<GetCustomerData> | undefined, NoInfer<GetCustomerData> | undefined>,
      options?: SetDataOptions
    ): Array<GetCustomerData | undefined>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCustomerSchema,
        GetCustomerData,
        TInfinite,
        GetCustomerParameters,
        GetCustomerError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<GetCustomerSchema, GetCustomerData, TInfinite, GetCustomerParameters, GetCustomerError>
    ): void;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Customer
     * @description Gets a customer.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerSchema,
            GetCustomerData,
            TInfinite,
            GetCustomerParameters,
            GetCustomerError
          >
        | QueryFiltersByQueryKey<GetCustomerSchema, GetCustomerData, TInfinite, GetCustomerParameters, GetCustomerError>
    ): number;
    schema: GetCustomerSchema;
    types: {
      parameters: GetCustomerParameters;
      data: GetCustomerData;
      error: GetCustomerError;
    };
  };
  /**
   * @summary Updates a customer's information.
   * @description Updates an existing customer.
   */
  updateCustomer: {
    /**
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateCustomerBody, UpdateCustomerParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateCustomerSchema,
        options: ServiceOperationMutationFnOptions<UpdateCustomerBody, UpdateCustomerParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateCustomerData, UpdateCustomerError>>
    ): Promise<RequestFnResponse<UpdateCustomerData, UpdateCustomerError>>;
    /**
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateCustomerParameters> | void
    ): ServiceOperationMutationKey<UpdateCustomerSchema, UpdateCustomerParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomer.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomer.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateCustomerBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateCustomerParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateCustomerSchema,
        UpdateCustomerData,
        UpdateCustomerParameters,
        TVariables,
        OperationError<UpdateCustomerError>,
        TContext
      >
    ): UseMutationResult<UpdateCustomerData, OperationError<UpdateCustomerError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomer.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomer.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<UpdateCustomerBody, UpdateCustomerParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateCustomerSchema,
        UpdateCustomerData,
        UpdateCustomerParameters,
        TVariables,
        OperationError<UpdateCustomerError>,
        TContext
      >
    ): UseMutationResult<UpdateCustomerData, OperationError<UpdateCustomerError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateCustomerTotal = qraft.customersService.updateCustomer.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateCustomerTotal = qraft.customersService.updateCustomer.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateCustomerBody,
            UpdateCustomerData,
            UpdateCustomerParameters,
            OperationError<UpdateCustomerError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCustomerSchema,
            UpdateCustomerBody,
            UpdateCustomerData,
            UpdateCustomerParameters,
            OperationError<UpdateCustomerError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateCustomerPendingMutationVariables = qraft.customersService.updateCustomer.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateCustomerMutationData = qraft.customersService.updateCustomer.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateCustomerData,
        OperationError<UpdateCustomerError>,
        MutationVariables<UpdateCustomerBody, UpdateCustomerParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateCustomerBody,
            UpdateCustomerData,
            UpdateCustomerParameters,
            OperationError<UpdateCustomerError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCustomerSchema,
            UpdateCustomerBody,
            UpdateCustomerData,
            UpdateCustomerParameters,
            OperationError<UpdateCustomerError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateCustomerData,
          OperationError<UpdateCustomerError>,
          MutationVariables<UpdateCustomerBody, UpdateCustomerParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateCustomerBody,
            UpdateCustomerData,
            UpdateCustomerParameters,
            OperationError<UpdateCustomerError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCustomerSchema,
            UpdateCustomerBody,
            UpdateCustomerData,
            UpdateCustomerParameters,
            OperationError<UpdateCustomerError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Updates a customer's information.
     * @description Updates an existing customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.customersService.updateCustomer.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.customersService.updateCustomer.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateCustomerBody,
              UpdateCustomerData,
              UpdateCustomerParameters,
              OperationError<UpdateCustomerError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateCustomerSchema,
              UpdateCustomerBody,
              UpdateCustomerData,
              UpdateCustomerParameters,
              OperationError<UpdateCustomerError>,
              TContext
            >
      ):
        | Mutation<
            UpdateCustomerData,
            UpdateCustomerError,
            MutationVariables<UpdateCustomerBody, UpdateCustomerParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateCustomerBody,
              UpdateCustomerData,
              UpdateCustomerParameters,
              OperationError<UpdateCustomerError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateCustomerSchema,
              UpdateCustomerBody,
              UpdateCustomerData,
              UpdateCustomerParameters,
              OperationError<UpdateCustomerError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateCustomerData,
          UpdateCustomerError,
          MutationVariables<UpdateCustomerBody, UpdateCustomerParameters>,
          TContext
        >
      >;
    };
    schema: UpdateCustomerSchema;
    types: {
      parameters: UpdateCustomerParameters;
      data: UpdateCustomerData;
      error: UpdateCustomerError;
      body: UpdateCustomerBody;
    };
  };
  /**
   * @summary Deletes a customer.
   * @description Deletes a customer.
   */
  deleteCustomerCustomersCustomerIdDelete: {
    /**
     * @summary Deletes a customer.
     * @description Deletes a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteCustomerCustomersCustomerIdDeleteBody,
        DeleteCustomerCustomersCustomerIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteCustomerCustomersCustomerIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteCustomerCustomersCustomerIdDeleteBody,
          DeleteCustomerCustomersCustomerIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<DeleteCustomerCustomersCustomerIdDeleteData, DeleteCustomerCustomersCustomerIdDeleteError>
      >
    ): Promise<
      RequestFnResponse<DeleteCustomerCustomersCustomerIdDeleteData, DeleteCustomerCustomersCustomerIdDeleteError>
    >;
    /**
     * @summary Deletes a customer.
     * @description Deletes a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<DeleteCustomerCustomersCustomerIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteCustomerCustomersCustomerIdDeleteSchema,
      DeleteCustomerCustomersCustomerIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Deletes a customer.
     * @description Deletes a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteCustomerCustomersCustomerIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteCustomerCustomersCustomerIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteCustomerCustomersCustomerIdDeleteSchema,
        DeleteCustomerCustomersCustomerIdDeleteData,
        DeleteCustomerCustomersCustomerIdDeleteParameters,
        TVariables,
        OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteCustomerCustomersCustomerIdDeleteData,
      OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Deletes a customer.
     * @description Deletes a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteCustomerCustomersCustomerIdDeleteBody,
        DeleteCustomerCustomersCustomerIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteCustomerCustomersCustomerIdDeleteSchema,
        DeleteCustomerCustomersCustomerIdDeleteData,
        DeleteCustomerCustomersCustomerIdDeleteParameters,
        TVariables,
        OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteCustomerCustomersCustomerIdDeleteData,
      OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Deletes a customer.
     * @description Deletes a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteCustomerCustomersCustomerIdDeleteTotal = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteCustomerCustomersCustomerIdDeleteTotal = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteData,
            DeleteCustomerCustomersCustomerIdDeleteParameters,
            OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteCustomerCustomersCustomerIdDeleteSchema,
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteData,
            DeleteCustomerCustomersCustomerIdDeleteParameters,
            OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Deletes a customer.
     * @description Deletes a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteCustomerCustomersCustomerIdDeletePendingMutationVariables = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteCustomerCustomersCustomerIdDeleteMutationData = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteCustomerCustomersCustomerIdDeleteData,
        OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
        MutationVariables<
          DeleteCustomerCustomersCustomerIdDeleteBody,
          DeleteCustomerCustomersCustomerIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteData,
            DeleteCustomerCustomersCustomerIdDeleteParameters,
            OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteCustomerCustomersCustomerIdDeleteSchema,
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteData,
            DeleteCustomerCustomersCustomerIdDeleteParameters,
            OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteCustomerCustomersCustomerIdDeleteData,
          OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
          MutationVariables<
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Deletes a customer.
     * @description Deletes a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteData,
            DeleteCustomerCustomersCustomerIdDeleteParameters,
            OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteCustomerCustomersCustomerIdDeleteSchema,
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteData,
            DeleteCustomerCustomersCustomerIdDeleteParameters,
            OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Deletes a customer.
     * @description Deletes a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.customersService.deleteCustomerCustomersCustomerIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteCustomerCustomersCustomerIdDeleteBody,
              DeleteCustomerCustomersCustomerIdDeleteData,
              DeleteCustomerCustomersCustomerIdDeleteParameters,
              OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteCustomerCustomersCustomerIdDeleteSchema,
              DeleteCustomerCustomersCustomerIdDeleteBody,
              DeleteCustomerCustomersCustomerIdDeleteData,
              DeleteCustomerCustomersCustomerIdDeleteParameters,
              OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteCustomerCustomersCustomerIdDeleteData,
            DeleteCustomerCustomersCustomerIdDeleteError,
            MutationVariables<
              DeleteCustomerCustomersCustomerIdDeleteBody,
              DeleteCustomerCustomersCustomerIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteCustomerCustomersCustomerIdDeleteBody,
              DeleteCustomerCustomersCustomerIdDeleteData,
              DeleteCustomerCustomersCustomerIdDeleteParameters,
              OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteCustomerCustomersCustomerIdDeleteSchema,
              DeleteCustomerCustomersCustomerIdDeleteBody,
              DeleteCustomerCustomersCustomerIdDeleteData,
              DeleteCustomerCustomersCustomerIdDeleteParameters,
              OperationError<DeleteCustomerCustomersCustomerIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteCustomerCustomersCustomerIdDeleteData,
          DeleteCustomerCustomersCustomerIdDeleteError,
          MutationVariables<
            DeleteCustomerCustomersCustomerIdDeleteBody,
            DeleteCustomerCustomersCustomerIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteCustomerCustomersCustomerIdDeleteSchema;
    types: {
      parameters: DeleteCustomerCustomersCustomerIdDeleteParameters;
      data: DeleteCustomerCustomersCustomerIdDeleteData;
      error: DeleteCustomerCustomersCustomerIdDeleteError;
      body: DeleteCustomerCustomersCustomerIdDeleteBody;
    };
  };
  /**
   * @summary Updates the locations for a customer.
   * @description Updates the locations for a customer.
   */
  updateCustomerLocations: {
    /**
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateCustomerLocationsBody,
        UpdateCustomerLocationsParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateCustomerLocationsSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateCustomerLocationsBody,
          UpdateCustomerLocationsParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateCustomerLocationsData, UpdateCustomerLocationsError>>
    ): Promise<RequestFnResponse<UpdateCustomerLocationsData, UpdateCustomerLocationsError>>;
    /**
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateCustomerLocationsParameters> | void
    ): ServiceOperationMutationKey<UpdateCustomerLocationsSchema, UpdateCustomerLocationsParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomerLocations.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomerLocations.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateCustomerLocationsBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateCustomerLocationsParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateCustomerLocationsSchema,
        UpdateCustomerLocationsData,
        UpdateCustomerLocationsParameters,
        TVariables,
        OperationError<UpdateCustomerLocationsError>,
        TContext
      >
    ): UseMutationResult<
      UpdateCustomerLocationsData,
      OperationError<UpdateCustomerLocationsError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomerLocations.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customersService.updateCustomerLocations.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateCustomerLocationsBody, UpdateCustomerLocationsParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateCustomerLocationsSchema,
        UpdateCustomerLocationsData,
        UpdateCustomerLocationsParameters,
        TVariables,
        OperationError<UpdateCustomerLocationsError>,
        TContext
      >
    ): UseMutationResult<
      UpdateCustomerLocationsData,
      OperationError<UpdateCustomerLocationsError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateCustomerLocationsTotal = qraft.customersService.updateCustomerLocations.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateCustomerLocationsTotal = qraft.customersService.updateCustomerLocations.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateCustomerLocationsBody,
            UpdateCustomerLocationsData,
            UpdateCustomerLocationsParameters,
            OperationError<UpdateCustomerLocationsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCustomerLocationsSchema,
            UpdateCustomerLocationsBody,
            UpdateCustomerLocationsData,
            UpdateCustomerLocationsParameters,
            OperationError<UpdateCustomerLocationsError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateCustomerLocationsPendingMutationVariables = qraft.customersService.updateCustomerLocations.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateCustomerLocationsMutationData = qraft.customersService.updateCustomerLocations.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateCustomerLocationsData,
        OperationError<UpdateCustomerLocationsError>,
        MutationVariables<UpdateCustomerLocationsBody, UpdateCustomerLocationsParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateCustomerLocationsBody,
            UpdateCustomerLocationsData,
            UpdateCustomerLocationsParameters,
            OperationError<UpdateCustomerLocationsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCustomerLocationsSchema,
            UpdateCustomerLocationsBody,
            UpdateCustomerLocationsData,
            UpdateCustomerLocationsParameters,
            OperationError<UpdateCustomerLocationsError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateCustomerLocationsData,
          OperationError<UpdateCustomerLocationsError>,
          MutationVariables<UpdateCustomerLocationsBody, UpdateCustomerLocationsParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateCustomerLocationsBody,
            UpdateCustomerLocationsData,
            UpdateCustomerLocationsParameters,
            OperationError<UpdateCustomerLocationsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCustomerLocationsSchema,
            UpdateCustomerLocationsBody,
            UpdateCustomerLocationsData,
            UpdateCustomerLocationsParameters,
            OperationError<UpdateCustomerLocationsError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Updates the locations for a customer.
     * @description Updates the locations for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.customersService.updateCustomerLocations.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.customersService.updateCustomerLocations.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateCustomerLocationsBody,
              UpdateCustomerLocationsData,
              UpdateCustomerLocationsParameters,
              OperationError<UpdateCustomerLocationsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateCustomerLocationsSchema,
              UpdateCustomerLocationsBody,
              UpdateCustomerLocationsData,
              UpdateCustomerLocationsParameters,
              OperationError<UpdateCustomerLocationsError>,
              TContext
            >
      ):
        | Mutation<
            UpdateCustomerLocationsData,
            UpdateCustomerLocationsError,
            MutationVariables<UpdateCustomerLocationsBody, UpdateCustomerLocationsParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateCustomerLocationsBody,
              UpdateCustomerLocationsData,
              UpdateCustomerLocationsParameters,
              OperationError<UpdateCustomerLocationsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateCustomerLocationsSchema,
              UpdateCustomerLocationsBody,
              UpdateCustomerLocationsData,
              UpdateCustomerLocationsParameters,
              OperationError<UpdateCustomerLocationsError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateCustomerLocationsData,
          UpdateCustomerLocationsError,
          MutationVariables<UpdateCustomerLocationsBody, UpdateCustomerLocationsParameters>,
          TContext
        >
      >;
    };
    schema: UpdateCustomerLocationsSchema;
    types: {
      parameters: UpdateCustomerLocationsParameters;
      data: UpdateCustomerLocationsData;
      error: UpdateCustomerLocationsError;
      body: UpdateCustomerLocationsBody;
    };
  };
}
/** @summary Search Customers */
export const searchCustomers = {
  schema: {
    method: 'get',
    url: '/customers/search',
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchCustomersSchema;
  [QraftServiceOperationsToken]: CustomersService['searchCustomers'];
};
/** @summary Create Customer */
export const createCustomer = {
  schema: {
    method: 'post',
    url: '/customers',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateCustomerSchema;
  [QraftServiceOperationsToken]: CustomersService['createCustomer'];
};
/**
 * @summary Get Customer
 * @description Gets a customer.
 */
export const getCustomer = {
  schema: {
    method: 'get',
    url: '/customers/{customer_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCustomerSchema;
  [QraftServiceOperationsToken]: CustomersService['getCustomer'];
};
/**
 * @summary Updates a customer's information.
 * @description Updates an existing customer.
 */
export const updateCustomer = {
  schema: {
    method: 'put',
    url: '/customers/{customer_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateCustomerSchema;
  [QraftServiceOperationsToken]: CustomersService['updateCustomer'];
};
/**
 * @summary Deletes a customer.
 * @description Deletes a customer.
 */
export const deleteCustomerCustomersCustomerIdDelete = {
  schema: {
    method: 'delete',
    url: '/customers/{customer_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteCustomerCustomersCustomerIdDeleteSchema;
  [QraftServiceOperationsToken]: CustomersService['deleteCustomerCustomersCustomerIdDelete'];
};
/**
 * @summary Updates the locations for a customer.
 * @description Updates the locations for a customer.
 */
export const updateCustomerLocations = {
  schema: {
    method: 'post',
    url: '/customers/{customer_id}/locations',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateCustomerLocationsSchema;
  [QraftServiceOperationsToken]: CustomersService['updateCustomerLocations'];
};
export const customersService = {
  searchCustomers,
  createCustomer,
  getCustomer,
  updateCustomer,
  deleteCustomerCustomersCustomerIdDelete,
  updateCustomerLocations,
} as const;
type SearchCustomersSchema = {
  method: 'get';
  url: '/customers/search';
  security: ['HTTPBearer'];
};
type SearchCustomersParameters = paths['/customers/search']['get']['parameters'];
type SearchCustomersData = paths['/customers/search']['get']['responses']['200']['content']['application/json'];
type SearchCustomersError = paths['/customers/search']['get']['responses']['422']['content']['application/json'];
type CreateCustomerSchema = {
  method: 'post';
  url: '/customers';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateCustomerParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateCustomerData = paths['/customers']['post']['responses']['201']['content']['application/json'];
type CreateCustomerError = paths['/customers']['post']['responses']['422']['content']['application/json'];
type CreateCustomerBody = paths['/customers']['post']['requestBody']['content']['application/json'];
type GetCustomerSchema = {
  method: 'get';
  url: '/customers/{customer_id}';
  security: ['HTTPBearer'];
};
type GetCustomerParameters = paths['/customers/{customer_id}']['get']['parameters'];
type GetCustomerData = paths['/customers/{customer_id}']['get']['responses']['200']['content']['application/json'];
type GetCustomerError = paths['/customers/{customer_id}']['get']['responses']['422']['content']['application/json'];
type UpdateCustomerSchema = {
  method: 'put';
  url: '/customers/{customer_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateCustomerParameters = paths['/customers/{customer_id}']['put']['parameters'];
type UpdateCustomerData = paths['/customers/{customer_id}']['put']['responses']['200']['content']['application/json'];
type UpdateCustomerError = paths['/customers/{customer_id}']['put']['responses']['422']['content']['application/json'];
type UpdateCustomerBody = paths['/customers/{customer_id}']['put']['requestBody']['content']['application/json'];
type DeleteCustomerCustomersCustomerIdDeleteSchema = {
  method: 'delete';
  url: '/customers/{customer_id}';
  security: ['HTTPBearer'];
};
type DeleteCustomerCustomersCustomerIdDeleteParameters = paths['/customers/{customer_id}']['delete']['parameters'];
type DeleteCustomerCustomersCustomerIdDeleteData = null;
type DeleteCustomerCustomersCustomerIdDeleteError =
  paths['/customers/{customer_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteCustomerCustomersCustomerIdDeleteBody = undefined;
type UpdateCustomerLocationsSchema = {
  method: 'post';
  url: '/customers/{customer_id}/locations';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateCustomerLocationsParameters = paths['/customers/{customer_id}/locations']['post']['parameters'];
type UpdateCustomerLocationsData =
  paths['/customers/{customer_id}/locations']['post']['responses']['200']['content']['application/json'];
type UpdateCustomerLocationsError =
  paths['/customers/{customer_id}/locations']['post']['responses']['422']['content']['application/json'];
type UpdateCustomerLocationsBody =
  paths['/customers/{customer_id}/locations']['post']['requestBody']['content']['application/json'];
